/*
 * @Author: luting
 * @Date: 2022-04-15 16:33:33
 * @lastEditors: luting
 * @LastEditTime: 2023-07-11 13:47:53
 */
import { CHANGEENVSTATUS } from 'root/store/constant';
import { envManageStatus } from './types';

const defaultStates: envManageStatus = {
  singleNodeId: '', // 主机节点id
  runtimeEnvId: '', // 环境环境id
  acitveKey: '1', // tab高亮值，在磁盘分区结束以后需要跳转到指定的tab
  isSuposInstalled: false, // 是否安装supos
  cluster: false, // 是否是集群
  hasHost: false, // 是否有主机节点  TODO  接口改动  此参数暂时没有
  hasOperatingEnv: false, // 是否有运行环境
  refersh: false, // 刷新集群主机管理列表
  colonySpinning: false, // 集群全部删除时loading
  initPassword: false, // 是否是初始密码
};

const envManage = (state = { ...defaultStates }, action: any) => {
  switch (action.type) {
    case CHANGEENVSTATUS: {
      return {
        ...state,
        ...action.payload,
      };
    }

    default:
      return state;
  }
};

export default envManage;
